import { DocumentLibrary } from "../model/library";

export const generateInitialLibraryState = (): DocumentLibrary => {
  return {
    entries: [],
    editingEntry: null,
  };
};
